import React, { ReactElement, useMemo } from 'react';
import { useRouter } from 'next/router';
import styled, { css } from 'styled-components';

import theme, {bp, color} from 'settings/theme';


type Props = {};

const CollectionSwitch: React.FC<Props> = (props) => {

  const router = useRouter();

  const collection = useMemo(() => {
    return router.query.collection === 'maps' ? 'maps' : 'merchants'
  }, [router.asPath])


  // Handle switch
  const handleSwitch = (newCollection) => {

    const newQuery = {...router.query, collection: newCollection};

    if(newCollection === 'merchants'){
      delete newQuery.collection;
    }

    router.push({pathname: router.pathname, query: newQuery});
    
  }


  return (
    <StyledCollectionSwitch className="collectionSwitch" collection={collection}>
      <div className="collectionSwitch-highlight"><span></span></div>
      <ul>
        <li>
          <button type="button" className={`${collection === 'merchants' ? 'is-active' : ''}`} onClick={() => handleSwitch('merchants')}>Merchants</button>
        </li>
        <li>
          <button type="button" className={`${collection === 'maps' ? 'is-active' : ''}`} onClick={() => handleSwitch('maps')}>Maps</button>
        </li>
      </ul>
    </StyledCollectionSwitch>
  );
};

export default CollectionSwitch;



const StyledCollectionSwitch = styled.nav<{collection: string}>`

  position: relative;
  width: 100%;
  height: 4rem;
  border-radius: 0.25rem;
  background-color: ${color.gray(80)};

  ul{

    position: relative;
    z-index: 1;
    display: flex;
    height: 100%;
    
    li{

      width: 50%;

      button{

        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        color: ${color.gray(0)};
        font-size: 0.875rem;

        &.is-active{
          color: ${color.gray(100)};
        }

      }

    }

  }

  .collectionSwitch-highlight{

    z-index: 0;
    position: absolute;
    left: ${props => props.collection === 'merchants' ? 0 : '50%' };
    width: 50%;
    height: 100%;
    padding: 0.25rem;
    transition: left 0.2s ease-out;

    span{
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 0.2rem;
      background-color: ${color.gray(20)};
    }

  }

  @media (min-width: ${bp(2)}){
    width: 20rem;
  }

`
